module.exports = __webpack_public_path__ + "static/media/SfondoPDF.492d4cdd.jpeg";